import styled from 'styled-components';
import { MediaBreakPointUp } from "../../../../theme";
export var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-16yeiyt-0"
})(["display:flex;flex-flow:column nowrap;gap:20px;max-width:743px;margin-top:68px;padding:24px 20px;border-radius:20px;border:0.5px solid #e7e2ff;background:#fff;@media screen and (max-width:", "){width:calc(100% - 30px);max-width:435px;margin:20px 15px 0;padding:24px 22px;}"], MediaBreakPointUp.sm);
export var StyledTitle = styled.h3.withConfig({
  displayName: "StyledTitle",
  componentId: "sc-16yeiyt-1"
})(["margin-bottom:0;color:#2c2842;font-size:24px;font-weight:600;line-height:150%;"]);
export var StyledDesc = styled.p.withConfig({
  displayName: "StyledDesc",
  componentId: "sc-16yeiyt-2"
})(["margin:8px 0 16px;color:#7f8294;font-size:14px;font-weight:400;line-height:24px;"]);
export var StyledBenefitList = styled.div.withConfig({
  displayName: "StyledBenefitList",
  componentId: "sc-16yeiyt-3"
})(["display:flex;flex-flow:row wrap;align-items:center;gap:24px;@media screen and (max-width:", "){justify-content:space-between;}"], MediaBreakPointUp.sm);
export var StyledBenefitItem = styled.div.withConfig({
  displayName: "StyledBenefitItem",
  componentId: "sc-16yeiyt-4"
})(["display:flex;align-items:center;gap:12px;color:#5f4dbc;font-size:14px;font-weight:400;line-height:24px;"]);
export var StyledCurveWrapper = styled.div.withConfig({
  displayName: "StyledCurveWrapper",
  componentId: "sc-16yeiyt-5"
})(["display:flex;flex-flow:column nowrap;gap:16px;padding:24px 16px;border-radius:20px;border:0.5px solid #e7e2ff;background:#fff;"]);
export var StyledCurveTitle = styled.h4.withConfig({
  displayName: "StyledCurveTitle",
  componentId: "sc-16yeiyt-6"
})(["color:#2c2842;font-size:18px;font-weight:600;line-height:150%;"]);
export var StyledCurveChart = styled.img.withConfig({
  displayName: "StyledCurveChart",
  componentId: "sc-16yeiyt-7"
})(["width:100%;"]);